import React, { FC } from 'react';
import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import * as PropTypes from 'prop-types';
import { background, layout } from 'styled-system';

import { responsiveType } from '../../internal/propTypeValidators';
import sx from '../../internal/styles/sx';
import { BackgroundImageType } from './types';

const invalidProps = ['width', 'height', 'display'];

const StyledBackgroundImage = styled('div', {
  shouldForwardProp: (prop) =>
    isPropValid(prop) && !invalidProps.includes(prop),
})<BackgroundImageType>(layout, background, sx);

const BackgroundImage: FC<BackgroundImageType> = ({
  alt,
  backgroundRepeat = 'no-repeat',
  backgroundPosition = 'center',
  backgroundSize = 'contain',
  width = '100%',
  height = '100%',
  ...props
}) => {
  return (
    <StyledBackgroundImage
      aria-label={alt}
      role="img"
      backgroundRepeat={backgroundRepeat}
      backgroundPosition={backgroundPosition}
      backgroundSize={backgroundSize}
      width={width}
      height={height}
      {...props}
    />
  );
};

BackgroundImage.propTypes = {
  alt: PropTypes.string,
  height: responsiveType(PropTypes.string),
  minWidth: responsiveType(PropTypes.string),
  maxWidth: responsiveType(PropTypes.string),
  minHeight: responsiveType(PropTypes.string),
  maxHeight: responsiveType(PropTypes.string),
  backgroundRepeat: responsiveType(PropTypes.string),
  backgroundPosition: responsiveType(PropTypes.string),
  backgroundSize: responsiveType(PropTypes.string),
  backgroundImage: responsiveType(PropTypes.string.isRequired),
  sx: PropTypes.object,
};

export default BackgroundImage;
